import React from "react";
import "./ProductCement.css";
import bucket from "./image/Bucket-Elevator-Chain.jpg";
import bucketelevator from "./image/Bucket-Elevator-chain-pitch.jpg";
import coal from "./image/Coal-feeder-chain.jpg";
import drag from "./image/Drag-flow-chain.jpg";
import enmass from "./image/Enmass-chain.jpg";
import hauledge from "./image/Hauledge-Chain.jpg";
import pan from "./image/Pan-chain.jpg";
import paul from "./image/Paul-chain.jpg";
import scrapper from "./image/Scrapper-chain.jpg";
import transport from "./image/Transportation-chain.jpg";
import appron from "./image/Appron-Feeder-chain.jpg";

const Cement = () => {
  return (
    <div>
      <div className="cementp">
        <p className="p">Cement Sector</p>
        <div className="p2">
          {/* <p>Swajit Engineering Pvt.Ltd: &gt; Products &gt; Cement Sector</p> */}
        </div>
      </div>

      <div className="cement">
        <div className="cem">
          <div className="ceimg">
            <figure>
              <img src={bucket} alt="Ash Chain" />
              <figcaption>Bucket Elevator Chain</figcaption>
            </figure>
          </div>

          <div className="ceimg">
            <figure>
              <img src={bucketelevator} alt="Drag Chain" />
              <figcaption>Bucket Elevator Chain 75mm</figcaption>
            </figure>
          </div>

          <div className="ceimg">
            <figure>
              <img src={coal} alt="Gate Chain" />
              <figcaption>Coal Feeder Chain</figcaption>
            </figure>
          </div>

          <div className="ceimg">
            <figure>
              <img src={drag} alt="Travelling Chain" />
              <figcaption>Drag & Flow Conveyor Chain</figcaption>
            </figure>
          </div>
        </div>

        <div className="cem">
          <div className="ceimg">
            <figure>
              <img src={enmass} alt="Travelling Chain" />
              <figcaption>Enmass Conveyor Chain</figcaption>
            </figure>
          </div>

          <div className="ceimg">
            <figure>
              <img src={hauledge} alt="Travelling Chain" />
              <figcaption>Hauledge Chain</figcaption>
            </figure>
          </div>

          <div className="ceimg">
            <figure>
              <img src={pan} alt="Travelling Chain" />
              <figcaption>Pan Conveyor Chain</figcaption>
            </figure>
          </div>

          <div className="ceimg">
            <figure>
              <img src={paul} alt="Travelling Chain" />
              <figcaption>Paul Retarder Chain</figcaption>
            </figure>
          </div>
        </div>

        <div className="cem">
          <div className="ceimg">
            <figure>
              <img src={scrapper} alt="Travelling Chain" />
              <figcaption>Scrapper Reclaimer Chain</figcaption>
            </figure>
          </div>

          <div className="ceimg">
            <figure>
              <img src={transport} alt="Travelling Chain" />
              <figcaption>Transportation Chain</figcaption>
            </figure>
          </div>

          <div className="ceimg">
            <figure>
              <img src={appron} alt="Travelling Chain" />
              <figcaption>Appron Feeder Chain</figcaption>
            </figure>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cement;
